var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./ChangeProfitArticle.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-61217c47!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChangeProfitArticle.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/ChangeProfitArticle.vue
// module id = 693
// module chunks = 0